import { BaseBlock } from "./BaseBlock";
import type { AccountActions } from "../screens/components/AccountActions";
import { ActionButtonElement } from "../elements/ActionButtonElement";

import type {
    AppState
} from "../app/state/AppState";

type Product =
    NonNullable<
        AppState["accountData"]
    >["products"][number];

export class ProductActionsBlock
    extends BaseBlock {

    private readonly product: Product;
    private readonly actions: AccountActions;

    private root!: HTMLElement;

    constructor(
            product: Product,
            actions: AccountActions
        ) {

            super();

            this.product = product;
            this.actions = actions;

        }

    public override mount(): void {

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =====================================================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        // ==========================================
        // ACTIVE
        // ==========================================

        if (this.product.state === "active") {

            if (this.product.continue_krok_id) {

                this.appendButton(

                    root,

                    "До навчання",

                    "primary-wide",

                    () => {

                        this.actions.openKrok(
                            this.product.continue_krok_id!
                        );

                    }

                );

            }

            const hasRenewalSubscription =
                this.product.subscriptions.some(
                    s => s.renewal_active
                );

            if (hasRenewalSubscription) {

                if (this.product.can_change_subscription) {

                    this.appendButton(

                        root,

                        "Змінити підписку",

                        "primary-wide",

                        () => {

                            this.actions.openSubscriptions(
                                this.product.product_id
                            );

                        }

                    );

                }

            } else {

                this.appendButton(

                    root,

                    "Оформити підписку",

                    "primary-wide",

                    () => {

                        this.actions.openSubscriptions(
                            this.product.product_id
                        );

                    }

                );

            }

            if (this.product.landing_url) {

                this.appendButton(

                    root,

                    "Відправити посилання другу",

                    "secondary-button",

                    () => {

                        this.actions.copyLandingLink(

                            this.product.title,

                            this.product.landing_url!

                        );

                    }

                );

            }

        }

        // ==========================================
        // RECOVERABLE
        // ==========================================

        if (this.product.state === "recoverable") {

            this.appendButton(

                root,

                "Оформити підписку",

                "primary-wide",

                () => {

                    this.actions.openSubscriptions(
                        this.product.product_id
                    );

                }

            );

            if (this.product.continue_krok_id) {

                this.appendButton(

                    root,

                    "До кроків, що залишилися",

                    "primary-wide",

                    () => {

                        this.actions.openKrok(
                            this.product.continue_krok_id!
                        );

                    }

                );

            }

            if (this.product.landing_url) {

                this.appendButton(

                    root,

                    "Відправити посилання другу",

                    "secondary-button",

                    () => {

                        this.actions.copyLandingLink(

                            this.product.title,

                            this.product.landing_url!

                        );

                    }

                );

            }

        }

        // ==========================================
        // NEVER SUBSCRIBED
        // ==========================================

        if (this.product.state === "never_subscribed") {

            this.appendButton(

                root,

                "Оформити підписку",

                "primary-wide",

                () => {

                    this.actions.openSubscriptions(
                        this.product.product_id
                    );

                }

            );

            if (this.product.landing_url) {

                this.appendButton(

                    root,

                    "Детальніше",

                    "primary-wide",

                    () => {

                        this.actions.openLanding(
                            this.product.landing_url!
                        );

                    }

                );

            }

        }

        return root;

    }

    private appendButton(

            root: HTMLElement,

            text: string,

            className: string,

            clicked: () => void

        ): void {

            const row =
                document.createElement("div");

            row.className =
                "account-actions";

            const button =
                new ActionButtonElement({

                    text,

                    className,

                    clicked

                });

            button.mount();

            row.appendChild(
                button.getRoot()
            );

            root.appendChild(
                row
            );

        }

}